<!-- Table actions -->
@if (tableActions?.length) {
  <div>
    @for (tableAction of tableActions; track tableAction) {
      <mad-primary-button class="table-action" (click)="onTableAction(tableAction)">
        {{ tableAction.label }}
      </mad-primary-button>
    }
  </div>
}

<!-- Row action buttons -->
<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-element="element">
    @for (rowAction of rowActions; track rowAction) {
      <button mat-menu-item class="row-action" (click)="onRowEvent($event, element, rowAction)">
        {{ rowAction.label }}
      </button>
    }
  </ng-template>
</mat-menu>

<!-- Table filter -->
@if (isFilterEnabled) {
  <mat-form-field>
    <mat-label>{{ filterLabel }}</mat-label>
    <input matInput (keyup)="onFilter($event?.target?.value)" placeholder="{{ filterPlaceholder }}" />
  </mat-form-field>
}

<!-- Table -->
@if (dataSource?.data?.length > 0) {
  <div class="mad-table">
    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="onSortingEvent($event)">
      <!-- Row actions column -->
      @if (rowActions?.length) {
        <ng-container [matColumnDef]="ACTION_COLUMN_NAME" sticky>
          <th mat-header-cell *matHeaderCellDef class="row-action-button"></th>
          <td mat-cell *matCellDef="let element" class="row-action-button">
            <mad-icon-button [matMenuTriggerData]="{ element: element }" [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </mad-icon-button>
          </td>
        </ng-container>
      }
      <!-- Columns with data -->
      @for (column of columns; track column) {
        <ng-container [matColumnDef]="column.label" [sticky]="column.isSticky">
          @if (column.isSortable) {
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header="{{ column.label }}"
              [arrowPosition]="column.isRightAligned ? 'before' : 'after'"
              [class.text-right]="column.isRightAligned"
            >
              {{ column.label }}
            </th>
          } @else {
            <th mat-header-cell *matHeaderCellDef [class.text-right]="column.isRightAligned">
              {{ column.label }}
            </th>
          }
          <td mat-cell *matCellDef="let element" [class.text-right]="column.isRightAligned">
            {{ element[column.dataPropertyName] }}
          </td>
        </ng-container>
      }
      <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
      <tr
        mat-row
        [class.clickable-table-row]="isRowClickable"
        (click)="onRowEvent($event, row)"
        *matRowDef="let row; columns: columnNames"
      ></tr>
    </table>
  </div>
} @else {
  <div class="noDataText">
    {{ noDataText }}
  </div>
}
<!-- Pagination -->
<mat-paginator
  [style.display]="isPaginationEnabled ? 'block' : 'none'"
  [pageSize]="defaultPageSize"
  [pageSizeOptions]="pageSizeOptions"
  showFirstLastButtons
>
</mat-paginator>

<!-- No data alert -->
